import React, { useRef, useState } from 'react'
import { StackAtom } from 'components/atoms/Stack.atom'

const OTP_LENGTH = 5

export const OtpInputMolecule = ({
  onComplete
}: {
  onComplete: (code: string) => void
}) => {
  const [otp, setOtp] = useState<string[]>(Array(OTP_LENGTH).fill(''))
  const inputsRef = useRef<(HTMLInputElement | null)[]>([])

  const focusInput = (index: number) => {
    inputsRef.current[index]?.focus()
  }

  const handleChange = (value: string, index: number) => {
    if (!/^\d?$/.test(value)) {
      return
    }

    const newOtp = [...otp]
    newOtp[index] = value
    setOtp(newOtp)

    if (value && index < OTP_LENGTH - 1) {
      focusInput(index + 1)
    }

    const isComplete = newOtp.every((digit) => digit !== '')
    if (isComplete) {
      onComplete(newOtp.join(''))
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === 'Backspace') {
      if (otp[index] === '') {
        if (index > 0) {
          focusInput(index - 1)
        }
      } else {
        const newOtp = [...otp]
        newOtp[index] = ''
        setOtp(newOtp)
      }
    }
  }

  return (
    <StackAtom $gap={10}>
      {otp.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputsRef.current[index] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          style={{
            width: '40px',
            height: '70px',
            fontSize: '24px',
            textAlign: 'center',
            border: '1px solid #ccc',
            borderRadius: '8px',
            flex: 1,
            background: '#3D3D3D',
            color: '#fff'
          }}
        />
      ))}
    </StackAtom>
  )
}
